<template>
  <div class="topbar">
    <b-button class="mr-2" variant="link" @click="CHANGE_THEME()">
      <b-icon v-if="GET_THEME==themes.light.value" icon="sun-fill" />
      <b-icon v-else-if="GET_THEME==themes.dark.value" icon="app-dark-mode" />
      <b-icon v-else icon="circle-half" />
    </b-button>
    <b-dropdown class="pages-dropdown" no-caret toggle-class="bg-transparent p-0 border-0">
      <template #button-content>
        <template v-if="GET_IS_LOGGED_IN">
          <b-avatar badge-variant="info">
            <template #badge>
              <b-icon icon="app-star" />
            </template>
          </b-avatar>
        </template>
        <b-icon v-else icon="three-dots-vertical" />
      </template>
      <b-dropdown-header v-if="GET_USER">
        <p class="mb-0">{{ GET_USER.name }}</p>
        <p class="mb-0">{{ GET_USER.email }}</p>
      </b-dropdown-header>
      <b-dropdown-divider v-if="GET_USER" />
      <template v-if="$route.meta && $route.meta.public">
        <b-dropdown-item v-if="GET_IS_LOGGED_IN" @click="$router.push('/dashboard')">Dashboard</b-dropdown-item>
        <b-dropdown-item v-else @click="$router.push('/login')">Login</b-dropdown-item>
      </template>
      <b-dropdown-group header="Public Pages">
        <b-dropdown-item @click="$router.push('/uptime-kuma-dashboard')">Uptime Kuma Dashboard</b-dropdown-item>
        <b-dropdown-item @click="$router.push('/esxi-servers-dashboard')">Esxi Servers Dashboard</b-dropdown-item>
        <b-dropdown-item @click="$router.push('/ipmi-servers-dashboard')">Ipmi Servers Dashboard</b-dropdown-item>
        <b-dropdown-item @click="$router.push('/ilo-servers-dashboard')">Ilo Servers Dashboard</b-dropdown-item>
        <b-dropdown-item @click="$router.push('/call-fail')">Call Fail</b-dropdown-item>
        <b-dropdown-item @click="$router.push('/check-fail')">Check Fail</b-dropdown-item>
        <b-dropdown-item @click="$router.push('/check-redis-fail')">Check Redis Fail</b-dropdown-item>
      </b-dropdown-group>
      <b-dropdown-divider v-if="GET_IS_LOGGED_IN" />
      <b-dropdown-item v-if="GET_IS_LOGGED_IN" @click="LOGOUT()" variant="danger">
        <b-icon icon="app-logout" /> Logout
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { GET_IS_DARK_MODE, GET_THEME, CHANGE_THEME, LOGOUT, GET_LANGUAGE, SET_LANGUAGE, GET_IS_LOGGED_IN, GET_USER } from '@/store/constants'
import { themes } from '@/constants'
import { languages } from '@/i18n'
export default {
  name: 'TopBar',
  computed: {
    ...mapGetters([
      GET_IS_LOGGED_IN,
      GET_USER,
      GET_THEME,
      GET_IS_DARK_MODE,
      GET_LANGUAGE,
    ]),
    language: {
      get(){ 
        return this.GET_LANGUAGE
      },
      set(value){ 
        this.$i18n.locale=value
        return this.SET_LANGUAGE(value)
      }
    },
    languages(){ return Object.values(languages) },
    themes(){ return themes },
  },
  methods: {
    ...mapActions([
      LOGOUT,
      CHANGE_THEME,
    ]),
    ...mapMutations([
      SET_LANGUAGE,
    ]),
  },
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .topbar {
    background-color: $dark-card;
    > .pages-dropdown {
      color: $white;
      :deep(> button) {
        color: $white;
      }
      :deep(.dropdown-item) {
        color: $white;
      }
    }
  }
}
.topbar {
  grid-area: topBar;
  background-color: $light-card;
  padding: 0.5rem;
  border-radius: 0.5rem;
  display: flex;
  justify-content: end;
  > .pages-dropdown {
    color: $black;
    :deep(> button) {
      color: $black;
    }
    :deep(.dropdown-item) {
      color: $black;
    }
  }
}
</style>